const initialState = {
    image: "",
    content: "",
    
};
const aboutUs = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_ABOUT_US':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default aboutUs;
